/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.temp.dereferenceScope'

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  scope: /*#__PURE__*/ l.string(),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  scope: /*#__PURE__*/ l.string(),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Allows finding the oauth permission scope from a reference */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, [
  'InvalidScopeReference',
])

export { main }

export const $lxm = $nsid
